<!-- 模板公式 -->
<template>
	<div class="modal-column">
		<div class="flex-1 p-20px" style="overflow-y: auto">
			<Form ref="form" :model="form" :rules="{}" mode="block">
				<div class="inline-form-item">
					<FormItem label="名称" prop="title" required>
						<Input type="text" v-model="form.title"/>
					</FormItem>
					<FormItem label="凭证字" prop="voucherWordId" required>
						<Select :datas="voucherWordList" keyName="id" titleName="word" v-model="form.voucherWordId" :deletable="false"/>
					</FormItem>
				</div>
				<div class="pzx">
					<FormItem label="凭证项">
						<vxe-table ref="itemsTable" :data="form.items" border @current-change="currentChangeEventAccountingDocuments" :row-config="{isCurrent: true, isHover: true}">
							<vxe-column width="80" align="center">
								<template #default="{row,rowIndex}">
									<!-- 加减行按钮 -->
									<span @click="pushItem(row)" class="fa fa-plus mr-16px text-hover"/>
									<span @click="popItem(row)" class="fa fa-minus red-color text-hover"/>
								</template>
							</vxe-column>
							<vxe-column field="summary" title="摘要">
								<template #default="{row}">
									<vxe-input v-model="row.summary"/>
								</template>
							</vxe-column>
							<vxe-column field="subjectId" title="科目">
								<template #default="{row}">
									<vxe-select v-model="row.subjectId" :options="subjectList" filterable transfer/>
								</template>
							</vxe-column>
							<vxe-column width="100" field="valueType" title="取值">
								<template #default="{row,rowIndex}">
									<vxe-select @change="valueTypeChange($event,rowIndex,row)" v-model="row.valueType" :options="[{label:'按公式取值',value:'按公式取值'},{label:'自动平衡',value:'自动平衡'}]" transfer/>
								</template>
							</vxe-column>
							<vxe-column width="100" field="eqRate" title="平衡比率(%)">
								<template #default="{row}">
									<vxe-input :disabled="row.valueType==='按公式取值'" type="float" v-model.number="row.eqRate"/>
								</template>
							</vxe-column>
							<vxe-column width="100" field="balanceDirection" title="方向">
								<template #default="{row}">
									<vxe-select v-model="row.balanceDirection" :options="[{label:'借',value:'借'},{label:'贷',value:'贷'}]" transfer/>
								</template>
							</vxe-column>
              <vxe-column width="100" field="isPrimarySubject" title="主科目">
                <template #default="{row,rowIndex}">
                  <vxe-select v-model="row.isPrimarySubject"  @change="primarySubjectChange($event,row,rowIndex)" :options="[{label:'是',value:1},{label:'否',value:0}]" transfer/>
                </template>
              </vxe-column>
						</vxe-table>
					</FormItem>
				</div>
			</Form>
			<!-- 公式 -->
			<div v-if="formula">
				<div class="m-16px flex items-center justify-around">
					<div class="label mr-8px">
						<text>科目</text>
					</div>
					<div class="flex-1">
						<Select placeholder="请选择科目" v-model="form.fromTag" :datas="originalSubjectList" keyName="id" titleName="fullName" filterable :filter="filter">
							<template #show="{value}">{{ value.code }} - {{ value.fullName }}</template>
							<template #item="{item}">{{ item.code }} - {{ item.fullName }}</template>
						</Select>
					</div>
					<!-- <div v-else class="flex-1">
						<Select placeholder="请选择数据项" v-model="form.fromTag" :datas="templateItemsData" filterable></Select>
					</div> -->
					<div class="label mx-8px">运算符号</div>
					<Select class="flex-1" v-model="form.calculation" dict="operation" placeholder="运算符号" :deletable="false"/>
					<div class="w-200px flex items-center">
						<div class="label mx-8px">取数规则</div>
						<Select class="w-120px" v-model="form.accessRules" placeholder="取数规则" :datas="accessRules" :deletable="false"/>
					</div>
					<Button :disabled="!form.fromTag" class="ml-8px" color="primary" @click="addItem">添加</Button>
				</div>
				<div class="p-16px h-400px">
					<vxe-table ref="formulaTable" height="auto" class="margin-top" :data="formulas" border :row-config="{height:40}">
						<vxe-column title="科目名称">
							<template #default="{row}">
								<!-- jxd -->
								{{ row.fromTag ? originalSubjectList.find(item => item.id === row.fromTag).code + ' ' + originalSubjectList.find(item => item.id === row.fromTag).name : '怎么会没有科目名称呢？'}}
							</template>
						</vxe-column>
						<vxe-column title="运算符号" :width="100" field="calculation" align="center">
							<template #default="{row}">
								<Select class="flex-1" v-model="row.calculation" dict="operation" placeholder="运算符号" :deletable="false"/>
							</template>
						</vxe-column>
						<vxe-column title="取数规则" :width="150" field="accessRules" align="center">
							<template #default="{row}">
								<Select class="w-120px" v-model="row.accessRules" placeholder="取数规则" :datas="accessRules" :deletable="false"/>
							</template>
						</vxe-column>
						<vxe-column title="取值比例" :width="150" field="valRate" align="center">
							<template #default="{row}">
<!--								<Select class="w-120px" v-model="row.accessRules" placeholder="取数规则" :datas="accessRules" :deletable="false"/>-->
                <vxe-input  type="float" v-model.number="row.valRate" placeholder="取值比例" :deletable="false"/>
							</template>
						</vxe-column>
						<vxe-column title="操作" :width="180" align="center">
							<template #default="{row,rowIndex}">
								<div class="actions">
									<span @click="upGo(rowIndex)"> <i class="fa fa-angle-up"></i> 上移</span>
									<span @click="downGo(rowIndex)"> <i class="fa fa-angle-down"></i> 下移</span>
									<span @click="removeItem(rowIndex)" class="red-color"> <i class="fa fa-trash"></i> 删除</span>
								</div>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
			</div>
			<!-- 自动平衡 -->
			<div v-else-if="auto" style="text-align: center;height:200px;line-height:200px;">
				<span>自动平衡</span>
			</div>
		</div>
		<div class="modal-column-btn">
			<Button @click="$emit('close')">取消</Button>
			<Button color="green" @click="submit" :loading="loading">{{ form.id ? '更新' : '保存' }}</Button>
		</div>
	</div>
</template>

<script>/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2022杭州财汇餐谋科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2023年4月19日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
// import {CheckoutTemplate} from "@/api/InitData";
import setting from "@/api/setting";
import CheckTemp from "@/api/CheckTemp";
import {CopyObj} from "@/js/common/utils";
import {message} from "heyui.ext";

export default {
	name: "CheckoutTemplateForm",
	props: {
		entity: Object,
		// subjectList: Array,
		// originalSubjectList:Array,//接口返回的原始科目列表jxd
		// voucherWordList: Array,
		accountSetsId: String,
	},
	data() {
		return {
			formula:false,
			auto:false,
			loading: false,
			accessRules:['余额','借方余额','贷方余额','发生额','借方发生额','贷方发生额','上期发生额','上期借方发生额','上期贷方发生额'],//公式规则jxd
			formulas: [],//公式临时存放区域
      		selectIdx: -1,
			form: {
				fromTag: null,
				calculation: '+',
				accessRules:'',
				id: null,
				title: null,
				voucherWordId: null,
				accountSetsId: this.accountSetsId,
				items: [
					{subjectId: null, balanceDirection: '借', valueType: "按公式取值",isPrimarySubject: 0, summary: "", eqRate: null,formulas: []},
					{subjectId: null, balanceDirection: '贷', valueType: "按公式取值",isPrimarySubject: 0, summary: "", eqRate: null,formulas: []},
				],
			},
      		subjectList:[],
     		originalSubjectList:[],
      		voucherWordList:[],
		}
	},
	methods: {
		filter(item, val) {
			return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
		},
		/**
		 * 添加公式
		 */
		 addItem() {
			if (this.form.fromTag) {
				// console.log(this.form.fromTag,this.form.calculation,this.form.accessRules)
				this.formulas.push({source:"SUBJECTS",fromTag:this.form.fromTag,calculation:this.form.calculation,accessRules:this.form.accessRules})
				// console.log(this.formulas)
        		this.form.items[this.selectIdx].formulas = this.formulas
				this.$refs.formulaTable.reloadData(this.formulas);
			}
		},
    /**
     * 删除公式公式
     */
    removeItem(idx) {
      this.formulas.splice(idx,1);
      this.$refs.formulaTable.reloadData(this.formulas)
	 },
	/**
	 * 高亮显示当前‘凭证项’选中行，并根据当前行是自动平衡还是按公式取数进行配置jxd
	 * @param {rowIndex=下标；rowData=行数据；rowData.valueType自动平衡/公式取数} row
	 */
	currentChangeEventAccountingDocuments(row){
		let rowIndex = row.$rowIndex;
		let rowData = row.row;
		console.log(row)
		this.selectIdx = rowIndex;
		// console.log(rowIndex,rowData)
		if(rowData.valueType != '自动平衡'){
			this.formula = true;
			this.auto = false
		if (!rowData.formulas) {
		rowData.formulas = [];
		}
		this.formulas = rowData.formulas;
		// if () {
		// }
		}else{
			this.auto = true;
			this.formula = false;
			row.formulas = []
		}
	},
	/**
	 * 切换当前行的value后，重新配置公式/自动平衡jxd
	 * @param {event.value = 按公式取值/自动平衡} row
	 */
	valueTypeChange(event,index,row){
		if(event.value != '自动平衡'){
			row.eqRate = ""
			this.formula = true;
			this.auto = false
		}else{
			this.auto = true;
			this.formula = false;
		}
	},
	pushItem(row) {
		this.$refs.itemsTable.insertAt({subjectId: null, balanceDirection: '贷', valueType: "按公式取值", summary: "", eqRate: null}, row);
	},
	popItem(row) {
		let {fullData} = this.$refs.itemsTable.getTableData();
		if (fullData.length > 2) {
			this.$refs.itemsTable.remove(row);
		}
	},
	submit() {
		//这里最后提交的数据格式应该是
		/**
		 * 模板的id
		 * 模板的title
		 * 凭证字voucherWordId
		 * 凭证模板明细项目items
		 * --明细项目包含
		 * [
		 * 	{
				"balanceDirection": "借",
				"eqRate": 100,
				"subjectId": "433708451487699055",
				"summary": "结转销售成本",
				"valueType": "按公式取值",
				"_X_ROW_KEY": "row_52"
				'formulas':[]//新增的公式存储数组，按公式取值的，在这里存储公式
					--公式内部应该包含 科目id，运算符号，取数规则，取值比例
			},
			{
				"balanceDirection": "借",
				"eqRate": 100,
				"subjectId": "433708451487699055",
				"summary": "结转销售成本",
				"valueType": "自动平衡",
				"_X_ROW_KEY": "row_52"
			}
			* ]
			*/
		let validResult = this.$refs.form.valid();
		let {fullData} = this.$refs.itemsTable.getTableData();
		let hasInvalidEqRate = fullData.some(val => !val.eqRate && val.valueType === '自动平衡');
		if (hasInvalidEqRate) {
			message.error("凭证项，平衡率不能为0，请检查！");
			return; // 这个return将结束当前函数的执行
		}
		let formulasFlg = false;
		let formulasFlgOther = false;
		fullData.forEach(val => {
			if(val.valueType == "按公式取值" && val.formulas.length > 0){
				val.formulas.forEach(formula => {
					if(!formula.valRate || formula.valRate <= 0){
						formulasFlg = true;
						return;
					}
					if(!formula.calculation || !formula.accessRules){
						formulasFlgOther = true;
						return;
					}
				})
			}
		})
		if(formulasFlg){
			message.error("公式项，取值比例不能0，请检查！");
			return
		}
		if(formulasFlgOther){
			message.error("公式项，运算符号和取数规则不能为空，请检查！");
			return
		}
		if (validResult.result && fullData.every(val => !!val.subjectId)) {
			let filter = fullData.filter(val => val.valueType === '自动平衡');
			if (filter.length > 0) {
				if (filter.reduce((total, item) => total + (item.eqRate || 0), 0) !== 100) {
					message.error("各项自动平衡合计必须为100%~");
					return
				}
			}
			this.loading = true;

			CheckTemp.save(Object.assign(this.form, {items: fullData})).then(() => {
				this.$emit('success');
			}).finally(() => {
				this.loading = false;
			})

		}
	},
    primarySubjectChange(event, row,rowIndex) {
      let val = event.value;
      if (val === 1) {
        let index = this.form.items.findIndex((item, idx) => item.isPrimarySubject === 1 && idx !== rowIndex);
        if (index!==-1) {
          message.error("只能有一个主科目");
          row.isPrimarySubject = 0;
          return;
        }
      }
    }
  },
	created() {
		if(this.entity !== null){
			this.form.voucherWordId = this.entity.voucherWordId;
			CopyObj(this.form, this.entity);
		}
		setting.subject.listAll().then(res=>{
			this.originalSubjectList = res.data
			this.subjectList = res.data.map(val => {
				// this.subjectMap[val.id] = val.code + "-" + val.fullName;
				return {
					value: val.id,
					label: val.code + "-" + val.fullName + "(" + val.balanceDirection + ")",
				}
			})
		})
		setting.voucherWord.list().then(({data}) => {
			this.voucherWordList = data || [];
		})
	}
}
</script>
